import { useQuery } from '@tanstack/react-query';
import api from '../api/client';

interface AppVersion {
  version: string;
  uptimeS: number;
}

/// Polling discreto da versão da app — refetch a cada 30s pra detectar
/// quando o service reinicia após um auto-update via fleet do VPS. Mostra
/// no rodapé do Sidebar pro operador saber em que versão está rodando.
export function useAppVersion() {
  return useQuery<AppVersion>({
    queryKey: ['app-version'],
    queryFn: async () => {
      const { data } = await api.get<AppVersion>('/version');
      return data;
    },
    refetchInterval: 30_000,
    staleTime: 25_000,
    retry: false,
  });
}
